import React from 'react';
import { Form, Col, Row, Button, Navbar, Container, Image, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import { CookiesProvider, useCookies } from 'react-cookie'

export function getTimeoutValue() {
    var cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith("userTimeoutSeconds="))
        ?.split("=")[1];
    if (!cookieValue)
        cookieValue='30m'
    return cookieValue;

}
class UserSettings extends React.Component {
    constructor(props) {
        super(props);
        console.log(props.location.state.user);
        this.state = {
            user: props.location.state.user,
            input: {
                firstname: props.location.state.user.firstname,
                lastname: props.location.state.user.lastname,
                email: props.location.state.user.email,
                phonenumber: props.location.state.user.phone,
                newEmail: '',
                newEmailConfirm: '',
            },
            errors: {},
            changeEmail: false,
            loading: false,
            timeout: getTimeoutValue(),
            selectedTimeout: getTimeoutValue()
        };

        this.showButton = this.showButton.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validatePassword = this.validatePassword.bind(this);
        this.setUserTimeout = this.setUserTimeout.bind(this);
        this.handleTimeoutChange = this.handleTimeoutChange.bind(this);
        this.TimeOutSelect = this.TimeOutSelect.bind(this);
    }

    handleTimeoutChange(event) {
        const re = /^[0-9\b]+$/;
        if (event.target.value === '' || re.test(event.target.value)) {
            this.setState({ timeout: event.target.value });
        }
    }

    TimeOutSelect(e) {
        let selTO = e.value;
        this.setState({ selectedTimeout: e.value });
        //alert('select option:' + e.value);
    }

    setUserTimeout() {
        var today = new Date();
        var expireDate = new Date();
        expireDate.setDate(today.getDate() + 365);
        var expires = expireDate.toUTCString();
        //alert(expires);
        var str = "userTimeoutSeconds=" + this.state.selectedTimeout + ';expires=' + expires + ';path=/;';
        document.cookie = str;
           
        const output = document.getElementById("userTimeoutSeconds");
        const cookieValue = document.cookie
            .split("; ")
            .find((row) => row.startsWith("userTimeoutSeconds="))
            ?.split("=")[1];
        alert(`Auto logout time set to: ${cookieValue}, \nExpire on ${expireDate}`);

    }

    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;

        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    validate(event) {

        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!input["firstname"]) {
            isValid = false;
            errors["firstname"] = "Please enter your name.";
        }
        if (!input["lastname"]) {
            isValid = false;
            errors["lastname"] = "Please enter your name.";
        }

        if (!input["phonenumber"] || !String(input["phonenumber"])
            .match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)) {
            isValid = false;
            errors["phonenumber"] = "Invalid phone number.";
        }

        if (!input["email"] || !String(input["email"])
            .toLowerCase()
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )) {
            isValid = false;
            errors["email"] = "Invalid email address.";
        }

        if (this.state.changeEmail) {
            if (!input["newEmail"] || !String(input["newEmail"])
                .toLowerCase()
                .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                )) {
                isValid = false;
                errors["newEmail"] = "Invalid email address.";
            }

            if (input["newEmail"] != input["newEmailConfirm"]) {
                isValid = false;
                errors["newEmail"] = "Email address does not match.";
            }

        }

        this.setState({
            errors: errors
        });

        return isValid;
    }

    validatePassword(event) {
        let input = this.state.input;
        input["password"] = event.target.value;
        let errors = this.state.errors;
        if (typeof input["password"] == "undefined" || !String(input["password"])
            .match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/)) {
            errors["password"] = <div style={{ lineHeight: .5, marginTop: 3 }}><p>Passwords require at least:</p><p>1 uppercase letter.</p><p>1 lowercase letter.</p><p>1 number.</p><p>1 symbol.</p><p>8-16 characters in length.</p></div>
        }
        else {
            errors["password"] = "";
        }

        this.setState({
            input: input,
            errors: errors
        });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '30px', backgroundColor: '#1F419B' }} variant="primary" disabled>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>;
        }
        else {
            return <Button style={{ marginLeft: '30px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                Save
            </Button>;
        }
    }

    handleSubmit(event) {

        event.preventDefault();

        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }

        this.setState({ loading: true });
        console.log(this.state);

        axios.get(`${Constants.apiURL}/api/Identity/UpdateUser`, {
            params: {
                username: this.state.user.username,
                oldEmail: this.state.user.email,
                newEmail: this.state.input.newEmail,
                firstname: this.state.input.firstname,
                lastname: this.state.input.lastname,
                phone: this.state.input.phonenumber
            }
        }).then(response => {
            console.log(response);
            if (response.status == 200 && response.data == true) {
                alert('Account updated.');
                let u = this.state.user;
                u.firstname = this.state.input.firstname;
                u.lastname = this.state.input.lastname;
                u.phone = this.state.input.phonenumber;
                if (this.state.input.newEmail != '') u.email = this.state.input.newEmail;
                let i = this.state.input;
                i.newEmail = '';
                i.newEmailConfirm = '';
                this.setState({ user: u, changeEmail: false, input: i });
            }
            else {
                alert(response.data);
            }
            this.setState({ loading: false });
        }).catch((error) => {
            this.setState({ loading: false });
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                alert('Unable to update your account. If this error persists, please email clientportal@boland.com for assistance.');
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                alert('Error contacting server. Please try again soon.')
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
        });
    }
    render() {
        const options = [
            '15m', '30m', '1hr', '2hr', '4hr', '8hr'];
        const defaultOption = options[1];
        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='userSettings' />
                <div>
                    <Form onSubmit={this.handleSubmit} noValidate >
                        <Row style={{ padding: '10px', margin: '10px', maxWidth: '800px' }} className="mb-3">
                            <Col md={6}>
                                <Form.Label style={{ paddingBottom: '24px' }} className="form-header">Your information</Form.Label>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Group as={Row}>
                                        <Col md={9}>
                                            <Form.Control type="email" name="email" value={this.state.user.email} disabled onChange={this.handleFormChange} required
                                                isInvalid={!!this.state.errors.email} />
                                        </Col>
                                        <Button className="mobile-m-t-10 mobile-m-l-10" style={{ width: 'auto' }} onClick={() => { this.setState({ changeEmail: !this.state.changeEmail }); }}>Change</Button>

                                    </Form.Group>
                                    <Form.Control.Feedback type='invalid'>
                                        {this.state.errors.email}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="newEmail" hidden={!this.state.changeEmail}>
                                    <Form.Label>New Email</Form.Label>
                                    <Form.Control type="input" name="newEmail" value={this.state.input.newEmail} onChange={this.handleFormChange}
                                        isInvalid={!!this.state.errors.newEmail} />
                                    <Form.Control.Feedback type='invalid'>
                                        {this.state.errors.newEmail}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="newEmailConfirm" hidden={!this.state.changeEmail}>
                                    <Form.Label>New Email Confirm</Form.Label>
                                    <Form.Control type="input" name="newEmailConfirm" value={this.state.input.newEmailConfirm} onChange={this.handleFormChange}
                                        isInvalid={!!this.state.errors.newEmail} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formFirstname">
                                    <Form.Label>First name</Form.Label>
                                    <Form.Control type="input" name="firstname" value={this.state.input.firstname} onChange={this.handleFormChange}
                                        isInvalid={!!this.state.errors.firstname} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formLastname">
                                    <Form.Label>Last name</Form.Label>
                                    <Form.Control type="input" name="lastname" value={this.state.input.lastname} onChange={this.handleFormChange} required
                                        isInvalid={!!this.state.errors.lastname} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formPhoneNumber">
                                    <Form.Label>Phone number</Form.Label>
                                    <Form.Control type="phone" name="phonenumber" value={this.state.input.phonenumber} onChange={this.handleFormChange} required
                                        isInvalid={!!this.state.errors.phonenumber} />
                                    <Form.Control.Feedback type='invalid'>
                                        {this.state.errors.phonenumber}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        {this.showButton()}
                    </Form>
                </div>
                <div style={{ position: 'absolute', top: '60px', left: '500px', border: 'solid 1 black' }}>
                    <Row style={{ padding: '10px', margin: '10px', maxWidth: '800px' }} className="mb-6">
                        <Form.Label style={{ paddingBottom: '24px' }} className="form-header">Set Auto Logout Time</Form.Label>
                        {/*<Form.Label>Timeout in seconds</Form.Label>*/}
                        <Form.Group as={Row}>
                            <Col md={3}>
                                {/* <Form.Control type="input" id="txtUserTimeoutSeconds" name="txtUserTimeoutSeconds" value={this.state.timeout} required onChange={this.handleTimeoutChange} />*/}
                                <Col md="auto">
                                    <Dropdown options={options} onChange={this.TimeOutSelect} value={this.state.timeout} />
                                </Col>
                            </Col>
                            <Col md={6}>
                                <Button style={{ backgroundColor: '#1F419B' }} variant="primary" onClick={this.setUserTimeout} >Set</Button>
                            </Col>

                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Label style={{ paddingBottom: '12px', paddingTop: '300px', paddingLeft:'60px', color: 'orange' }} >Build for .NET 10</Form.Label>
                    </Row>
                </div>


            </div>
        );
    }
}

export default UserSettings;
